import { api } from "../api";

export const createDefaultFolders = async (projectNumber) => {
  const url = `/files/create/${encodeURIComponent(projectNumber)}?default=true`;
  return await api.post(url);
};

export const createFolder = async (directoryPath) => {
  return await api.post(`/files/create/${encodeURIComponent(directoryPath)}`);
};

// Função para listar arquivos em um diretório específico no OneDrive
export const listFiles = async (directoryPath) => {
  try {
    const response = await api.get(`/files/path/${encodeURIComponent(directoryPath)}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao listar arquivos:", error);
    throw error;
  }
};
// Função para listar arquivos em um diretório específico no OneDrive pelo ID
export const listFilesById = async (id) => {
  try {
    const response = await api.get(`/files/id/${encodeURIComponent(id)}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao listar arquivos:", error);
    throw error;
  }
};
export const getFilePreviewLink = async (id) => {
  try {
    const response = await api.get(`/files/preview?id=${encodeURIComponent(id)}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao listar arquivos:", error);
    throw error;
  }
};

export const getFileLinks = async (fileId) => {
  try {
    const response = await api.get(`/files/download/${encodeURIComponent(fileId)}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter links do arquivo:", error);
    throw error;
  }
};

export const uploadFile = async (directoryPath, fileName, file, options = {}) => {
  const formData = new FormData();
  formData.append("directoryPath", directoryPath);
  formData.append("fileName", fileName);
  formData.append("fileContent", file); // This should match 'fileContent' used in multer
  if (options.imageProfile) {
    formData.append("imageProfile", options.imageProfile);
  }

  try {
    const response = await api.post("/files", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer upload para:", error);
    throw error;
  }
};

// Função para baixar um arquivo do OneDrive
export const downloadFile = async (fileId) => {
  try {
    const response = await api.get(`/files/download/${fileId}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao baixar arquivo :", error);
    throw error;
  }
};

// Função para deletar um arquivo do OneDrive
export const deleteFile = async (fileId) => {
  return await api.delete(`/files/${fileId}`);
};

// Obtém o binário do arquivo para visualização inline (evita bloqueio de iframe com URL direta)
export const getOneDriveInlineBlob = async (fileId) => {
  const response = await api.get(`/files/inline/${encodeURIComponent(fileId)}`, {
    responseType: "blob",
  });
  return response.data;
};

// Função para fazer upload de arquivo de comentário
export const uploadFileToOneDrive = async (file, projectNumber) => {
  try {
    const formData = new FormData();
    formData.append('fileContent', file);
    formData.append('fileName', file.name);
    formData.append('directoryPath', `${projectNumber}/Comentarios`);
    
    const response = await api.post("/files", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Erro ao fazer upload de anexo:", error);
    throw error;
  }
};

// Função para baixar arquivo de comentário
export const downloadFileFromOneDrive = async (fileId, fileName) => {
  try {
    // Primeiro, busca o downloadUrl do arquivo
    const urlResponse = await api.get(`/files/download/${fileId}`);
    const downloadUrl = urlResponse.data.downloadUrl;
    
    if (!downloadUrl) {
      throw new Error('URL de download não encontrada');
    }
    
    // Agora faz o download direto da URL do OneDrive
    const response = await fetch(downloadUrl);
    const blob = await response.blob();
    
    // Criar link para download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName; // Usar .download ao invés de setAttribute
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return blob;
  } catch (error) {
    console.error("Erro ao baixar arquivo:", error);
    throw error;
  }
};
